import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "contexts";
import { ApiDataResponse } from "types/api";
import { ExceptionHandlingType } from "types/apiServiceTypes";
import { PublicLeaderboardProvider } from "types/leaderboard";

export function useLeaderboardActiveProviders() {
  const { apiService } = useAppContext();
  return useQuery<PublicLeaderboardProvider[]>({
    queryKey: [useLeaderboardActiveProviders.name],
    queryFn: async () => {
      const response = await apiService.get<ApiDataResponse<PublicLeaderboardProvider[]>>(
        "/leaderboard/active-leaderboard-providers",
        {
          exceptionHandlingType: ExceptionHandlingType.AUTOMATIC,
        }
      );
      return response.data;
    },
    initialData: [],
  });
}
